import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const Dashboard = () => {
  const { userRole, isAuthenticated, isInitialLoad, loading, userName } = useContext(AuthContext);

  const isReady = isAuthenticated && userRole && userName && !loading && !isInitialLoad;

  if (!isReady) {
    // ⏳ Shimmer loader
    return (
      <div className="max-w-3xl mx-auto mt-12 px-6 py-8 bg-white shadow-lg rounded-lg animate-pulse">
        <div className="h-8 w-2/3 mb-4 rounded shimmer"></div>
        <div className="h-4 w-1/2 mb-6 rounded shimmer"></div>
        <div className="h-6 w-1/4 mb-2 rounded shimmer"></div>
        <div className="h-4 w-full rounded shimmer"></div>
      </div>
    );
  }

  console.log('[Dashboard] Render: userName =', userName, '| userRole =', userRole);

  return (
    <div className="max-w-3xl mx-auto mt-12 px-6 py-8 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        Selamat datang, {userName} 👋
      </h1>
      <p className="text-gray-600 mb-6">
        Ini adalah dashboard Anda. Anda login sebagai{' '}
        <span className="font-medium text-blue-600">{userRole}</span>.
      </p>

      <section className="border-t pt-6 mt-6">
        <h2 className="text-xl font-semibold text-gray-700 mb-2">📄 Laporan Anda</h2>
        <p className="text-gray-500 italic">Belum ada laporan yang ditampilkan.</p>
      </section>
    </div>
  );
};

export default Dashboard;
